import { registerModal } from 'features/Modal/ModalRegistry'
import NumbersFormModal from './NumbersFormModal'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'NUMBERS_FORM_MODAL'
registerModal(modalType, NumbersFormModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {
      fullScreen: true,
    },
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersFormModal/NumbersFormModal.action.js